import { Settings } from "../utils/settings";
import { LiturgyItem } from "./types";

export const getSalutation = (settings: Settings) => {
    const result: LiturgyItem[] = [];
    if (settings.salutation === "o lord hear our prayer") {
        result.push({
            type: "chant",
            boldMode: "alternate",
            tone: "2.1",
            pointedText: {
                clef: "f5",
                verses: [
                    {
                        secondHalf: [
                            {
                                syllables: [
                                    {
                                        text: "O",
                                        notes: ["3"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "Lord",
                                        notes: ["5"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "hear",
                                        notes: ["4", "5"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "our",
                                        notes: ["5", "4"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "prayer.",
                                        notes: ["4"],
                                        long: true,
                                        dotBefore: false,
                                    },
                                ],
                            },
                        ],
                    },
                    {
                        secondHalf: [
                            {
                                syllables: [
                                    {
                                        text: "And",
                                        notes: ["3"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "let",
                                        notes: ["5"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "our",
                                        notes: ["5"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "cry",
                                        notes: ["5"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "come",
                                        notes: ["4", "5"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "un",
                                        notes: ["5", "4"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                    {
                                        text: "to",
                                        notes: ["4"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "thee.",
                                        notes: ["4"],
                                        long: true,
                                        dotBefore: false,
                                    },
                                ],
                            },
                        ],
                    },
                ],
            },
        });
    } else {
        result.push({
            type: "chant",
            boldMode: "alternate",
            tone: "2.1",
            pointedText: {
                clef: "f5",
                verses: [
                    {
                        secondHalf: [
                            {
                                syllables: [
                                    {
                                        text: "The",
                                        notes: ["3"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "Lord",
                                        notes: ["5"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "be",
                                        notes: ["4", "5"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "with",
                                        notes: ["5", "4"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "you.",
                                        notes: ["4"],
                                        long: true,
                                        dotBefore: false,
                                    },
                                ],
                            },
                        ],
                    },
                    {
                        secondHalf: [
                            {
                                syllables: [
                                    {
                                        text: "And",
                                        notes: ["3"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "with",
                                        notes: ["5"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "thy",
                                        notes: ["4", "5"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                ],
                            },
                            {
                                syllables: [
                                    {
                                        text: "spi",
                                        notes: ["5", "4"],
                                        long: false,
                                        dotBefore: false,
                                    },
                                    {
                                        text: "rit.",
                                        notes: ["4"],
                                        long: true,
                                        dotBefore: false,
                                    },
                                ],
                            },
                        ],
                    },
                ],
            },
        });
    }

    result.push({
        type: "chant",
        boldMode: "none",
        tone: "2.1",
        pointedText: {
            clef: "f5",
            verses: [
                {
                    secondHalf: [
                        {
                            syllables: [
                                {
                                    text: "Let",
                                    notes: ["5"],
                                    long: false,
                                    dotBefore: false,
                                },
                            ],
                        },
                        {
                            syllables: [
                                {
                                    text: "us",
                                    notes: ["4", "5"],
                                    long: false,
                                    dotBefore: false,
                                },
                            ],
                        },
                        {
                            syllables: [
                                {
                                    text: "pray.",
                                    notes: ["5"],
                                    long: true,
                                    dotBefore: false,
                                },
                            ],
                        },
                    ],
                },
            ],
        },
    });

    return result;
};
